<template>
    <b-navbar-nav>
        <slot />
    </b-navbar-nav>
</template>

<script>
import { BNavbarNav } from 'bootstrap-vue'

export default {
    components: { BNavbarNav },
}
</script>